// extracted by css-extract-rspack-plugin
export default {"FADE_TIMEOUT":"225","fadeTimeout":"225","important":"_bfd807e6","container":"_99680b87","fade":"_6fc766c6"};